export default {
  "FE.1": "Unauthorized",
};
